
<template>
  <div class="courseRow">
    <waterfall
      :col="2"
      :width="itemWidth"
      :gutterWidth="gutterWidth"
      :data="dataList"
      :isTransition="false"
    >
      <template
        >     
        <div
          class="recommendItem"
          v-for="(item, index) in dataList"
          :key="index"
          :class="{ specialItem: item.type == 1 }"
          @click="toCourseDetails(item.id, item.type)"
        >
          <div class="recommendImg">
            <div
              class="specialImg"
              :class="{ special: item.type == 1 }"
            >
              <van-image
                width="100%"
                height="100%"
                fit="cover"
                :src="item.image"
              />
            </div>
            <!-- <img class="specialImg" :src="item.image" :class="{ special: item.type == 1 }" /> -->
            <img
              v-if="item.type == 3"
              src="./../../../assets/school/picturetext.png"
              class="tag"
            />
            <img
              v-if="item.type == 2"
              src="./../../../assets/school/video.png"
              class="tag"
            />
            <img
              v-if="item.type == 4"
              src="./../../../assets/school/audio.png"
              class="tag"
            />
            <div :class="{ specialDiv: item.type == 1 }"></div>
          </div>
          <p :class="{ isHomeTitle: isHome }">{{ item.title }}</p>
          <div>
            <span class="tipColor">
              <span v-if="item.cost_type == 1">免费</span>
            </span>
            <span class="tip">{{ item.total_study_num }}次学习</span>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    isHome: {
      type: Boolean,
      default: false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      col: "2",
      page: 1,
    };
  },
  computed: {
    itemWidth() {
      return 326 * 0.5 * (document.documentElement.clientWidth / 375); // #rem布局 计算宽度
    },
    gutterWidth() {
      return 30 * 0.5 * (document.documentElement.clientWidth / 375); //#rem布局 计算x轴方向margin(y轴方向的margin自定义在css中即可)
    },
  },
  mounted() {},
  methods: {
    toCourseDetails(id, type) {
      if (!this.isPreview) {
        let path;
        let channel = 2;
        switch (type) {
          case 1:
            path = "/school/courseDetailsSpecial";
            channel = 1;
            break;
          case 2:
            path = "/school/courseDetailsVideo";
            break;
          case 3:
            path = "/school/courseDetailsPicture";
            break;
          case 4:
            path = "/school/courseDetailsAudio";
            break;
          default:
          // console.log(type);
        }
        this.$router.push({
          path: path,
          query: {
            id: id,
            channel: channel,
          },
        });
      }
    },
  },
};
</script>

<style>
.courseRow {
  margin-top: -16px;
}
.recommendItem {
  border-radius: 4px;
  border: 1px solid #eeeeee;
  margin-top: 16px;
  background-color: #ffffff;
}
.recommendItem .recommendImg {
  width: 100%;
  height: 108px;
  position: relative;
}
/* .recommendItem img {
  width: 100%;
  height: 100%;
  border-radius: 4px 4px 0 0;
  position: absolute;
  z-index: 2;
} */
.recommendItem .specialImg {
  width: 100%;
  height: 100%;
  border-radius: 4px 4px 0 0;
  background-color: #ffffff;
  position: relative;
  z-index: 9;
}
.courseRow .van-image__img{
  border-radius: 4px 4px 0 0;
}
.recommendItem .recommendImg .tag {
  width: 40px;
  height: 14px;
  position: absolute;
  top: 4px;
  left: 6px;
  z-index: 10;
}
.specialItem {
  margin-top: 24px;
}
.specialItem .recommendImg {
  height: 100px;
}
.recommendItem .special {
  height: 100px;
}
.recommendItem .specialDiv {
  width: 88%;
  height: 108px;
  background-color: #dfe1ec;
  border-radius: 4px;
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}
.recommendItem p {
  color: #404247;
  font-size: 15px;
  font-weight: 600;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
  margin: 10px 0;
}
.recommendItem .isHomeTitle {
  height: 18px;
}
.recommendItem > div:last-child {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  margin-bottom: 8px;
}
.recommendItem .tipColor {
  color: #eb4872;
  font-size: 14px;
}
.recommendItem .tip {
  color: #9ca1ad;
  font-size: 12px;
}
</style>